import PolicyModalAgreement from './PolicyModalAgreement';

export default PolicyModalAgreement;
